jQuery(function () {

    //*******************************helper functions************************
    function setPopupClosed(storageItem){
        localStorage.setItem(storageItem, new Date().toString());
    }
    function getPopupClosed(storageItem){
        if(!localStorage.getItem(storageItem))
            return false;
        const wasClosedOn = new Date(localStorage.getItem(storageItem));
        if(wasClosedOn.toString() === 'Invalid Date')
            return false;

        //set it for two days
        const twoDaysAgo = 48 * 60 * 60 * 1000;

        if(new Date() - wasClosedOn > twoDaysAgo){
            localStorage.removeItem(storageItem);
            return false;
        }
        return true;
    }
    //***********************************************************************

    $(document).ready(function (event) {
        if($.trim($('#popup-content > div').html()).length > 0) {
            $('#popup-content').find(".main-slider.slick-slider.slick-initialized").slick('unslick');

            if(!getPopupClosed("popupclosed")){
                var popUpContent = "<div class='modal'>" + $("#popup-content").html() + "</div>";
                var instance = lity(popUpContent);

                var element = instance.element();
                element.addClass("popup-lity");
                element.find(".lity-close").attr("title", "Fenster schließen");

                window.pixelpoint.images.initializeErrors($(".popup-lity"));

                setTimeout(function(){
                    window.ppComponents.sliders.main.init($(".popup-lity").find(".main-slider"));
                },100);
            }
        }

        if($(".dce-popup.small").length > 0) {
            if(!getPopupClosed("popupsmallclosed")){
                $('#popup-small-content').removeClass("hide");
                $(".dce-popup.small").each(function(){
                    let $popup = $(this);
                    let openAfter = $popup.attr("data-open-after");
                    openAfter = parseFloat(openAfter.replace(",", "."));
                    window.setTimeout(function(){
                        $popup.addClass("show-popup");
                        window.pixelpoint.tagManager.event('advertismentPopupDisplayed',{'action':'popupDisplayed'});

                        window.setTimeout(function(){
                            $popup.find(".close-button").css("aspect-ratio", "1/1");
                        }, 2000);

                    }, openAfter * 1000);
                });
            }
            else {
                $('#popup-small-content').addClass("hide");
            }
        }
    });

    // set session var when close lity
    $(document).on('lity:close', function(event, instance) {
        var elem = instance.element();

        if(elem.hasClass("popup-lity")){
            setPopupClosed("popupclosed");
        }
    });
    $(document).on('click','.popup-lity .brandenbutton', (event) => {
        setPopupClosed("popupclosed");
    });


    $(document).on('click','.dce-popup.small .brandenbutton', (event) => {
        let $elem = $(event.target);

        if($elem.hasClass("brandenbutton close-button") || $elem.parent().hasClass("brandenbutton close-button")){
            $elem.closest(".dce-popup").removeClass("show-popup");
            $elem.closest(".dce-popup").addClass("hide-popup");
        }

        setPopupClosed("popupsmallclosed");
    });
});